module.exports = __webpack_public_path__ + "assets/59790677ca1dc810a6bde356764bb8a7.png";